export * from './slide.module';
export * from './components/slide-component';
export * from './components/slide-controller';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ion2-image-slide/dist/index.js
// module id = 153
// module chunks = 20